import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Row, Col, DatePicker, Drawer, Divider } from 'antd';
import BaseRadioList from '@/components/Elements/BaseRadios';
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import { _newLine, isValidDateForm } from '@/utils/helpers';
import { createBranch, updateBranch } from '@/redux/actions/branchActions';
import { getListProvinces, getListWards } from '@/redux/actions/regionsActions';

class BranchForm extends Component {
    constructor() {
        super();
        this.state = {
            wards: [],
            loadingForm: false
        };
    }

    componentDidMount() {
        this.props.getListProvinces();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentItem != this.props.currentItem) {
            this.props.getListWards({ province_code: nextProps?.currentItem?.province_code }).then(res => {
                this.props.form.resetFields(['ward_code']);
                this.setState({ wards: res.data })
            })
        }
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {

            if (!err) {
                try {
                    this.setState({ loadingForm: true })
                    console.log('values: ', values)

                    if (this.props.currentItem) {
                        await this.props.updateBranch(this.props.currentItem.id, values);
                        this.onClose();
                    } else {
                        await this.props.createBranch(values);
                        this.onClose();
                    }
                    this.props.reloadData();
                } catch (error) {
                    this.setState({ loadingForm: false });
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({
            loadingForm: false
        })
    }

    loadWards(province_code) {
        if (province_code) {
            this.props.getListWards({ province_code: province_code }).then(res => {
                this.props.form.setFieldsValue({ ward_code: null });
                this.setState({ wards: res.data })
            })
        }
    }

    render() {
        var { wards, loadingForm } = this.state;
        var { visible, currentItem, list_provinces, users } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title={currentItem ? "Sửa cơ sở" : "Thêm mới cơ sở"}
                onOk={(e) => this.submit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '45%'}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => this.onClose()}>
                            Huỷ
                        </Button>
                        <Divider type="vertical" />
                        <Button loading={loadingForm} key="submit" type="primary" onClick={(e) => this.submit(e)}>
                            {currentItem ? "Cập nhật" : "Thêm mới"}
                        </Button>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={8}>
                                <Form.Item label="Tên cơ sở">
                                    {getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.name : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="Mã cơ sở">
                                    {getFieldDecorator('code', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.code : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="Ngày thành lập">
                                    {getFieldDecorator('founding_date', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? isValidDateForm(currentItem.founding_date, false) : null
                                    })(<DatePicker
                                        format="DD/MM/YYYY"
                                        style={{ width: '100%' }}
                                        placeholder="Chọn ngày"
                                    />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="Tỉnh/Thành phố">
                                    {getFieldDecorator("province_code", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.province_code : null,
                                        normalize: value => value !== undefined ? value : null
                                    })(
                                        <BaseSelect
                                            options={list_provinces || []}
                                            optionValue="code"
                                            optionLabel="name"
                                            showSearch
                                            placeholder="Tỉnh/Thành phố"
                                            style={{ width: '100%' }}
                                            onChange={(code) => this.loadWards(code)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="Phường/Xã">
                                    {getFieldDecorator("ward_code", {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.ward_code : null,
                                        normalize: value => value !== undefined ? value : null
                                    })(
                                        <BaseSelect
                                            options={wards || []}
                                            optionValue="code"
                                            optionLabel="name"
                                            showSearch
                                            placeholder="Phường/Xã"
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="Địa chỉ sơ sở">
                                    {getFieldDecorator('address', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.address : null
                                    })(
                                        <Input />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="Số nhà">
                                    {getFieldDecorator('house_number', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.house_number : null
                                    })(
                                        <Input />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="Người quản lý">
                                    {getFieldDecorator('management_user_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.management_user_id : null,
                                        normalize: value => value !== undefined ? value : null
                                    })(<BaseSelect
                                        options={users || []}
                                        optionValue="user_id"
                                        optionLabel="display_name"
                                        showSearch
                                        placeholder="Chọn người quản lý"
                                        style={{ width: '100%' }}
                                    />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="Số điện thoại">
                                    {getFieldDecorator('phone_number', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.phone_number : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Zalo OA Id">
                                    {getFieldDecorator('zalo_oa_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.zalo_oa_id : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Zalo ZNS Id">
                                    {getFieldDecorator('zalo_zns_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.zalo_zns_id : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Trạng thái cơ sở">
                                    {getFieldDecorator('status', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.status : 1
                                    })(
                                        <BaseRadioList
                                            options={[
                                                { label: "Active", value: 1 },
                                                { label: "Inactive", value: 0 }
                                            ]}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.note) : null
                                    })(
                                        <Input.TextArea />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        list_provinces: state.regionsReducer.list_provinces,
        users: state.config.users
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createBranch: (data) => dispatch(createBranch(data)),
        updateBranch: (id, data) => dispatch(updateBranch(id, data)),
        getListProvinces: () => dispatch(getListProvinces()),
        getListWards: (filter) => dispatch(getListWards(filter)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'BranchForm' })(BranchForm));
